<!--
 * @Author: your name
 * @Date: 2021-06-24 11:07:32
 * @LastEditTime: 2022-01-06 13:20:06
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\views\Home.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>

  <div class="menuList" >
    <!-- {{url}} -->
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-overlay :show="LodingShow" style="display:flex;align-items: center; justify-content:center;">
          <van-loading type="spinner" />
      </van-overlay>
    <van-swipe :autoplay="3000" style="width:95%;height:55vw;margin:auto;padding-top:1rem;" v-if="first">
        <van-swipe-item v-for="(image, index) in images" :key="index" >
            <img style="width:100%;height:100%;" :src="image.url" fit="contain"/>
        </van-swipe-item>
    </van-swipe>
    <div class="info bg" v-if="first">
        <div style="padding:0rem 10vw;display:flex;justify-content:space-between;height:13vw;align-items:center;">
            <div>学生信息</div>
            <div style="color:#1989fa;font-size:1rem;" @click="changeShow">切换角色</div>
        </div>
        <div style="padding:3vw 10vw;display:flex; align-items:center;height:20vw;">
            <van-image
                round
                width="3rem" 
                 fit="cover"
                 v-if="currentInfo.avatar"
                error="require('./img/avatar.png')"
                :src="currentInfo.avatar" rel="external nofollow" 
                >
                <!-- <template v-slot:error>加载失败</template> -->
            </van-image>
             <van-image
                round
                width="3rem"
                 fit="cover"
                 v-else
                :src="require('./img/avatar.png')" rel="external nofollow" 
                >
                <template v-slot:error>加载失败</template>
            </van-image>
            <div style="width:100%;display:flex;justify-content:space-between;align-items:center">
                <div style="margin-left:1rem;width:50%">
                    <div>{{currentInfo.name}}</div>
                    <div style="font-size:0.75rem;color:#ccc">{{currentInfo.deptName}}</div>
                    <div style="font-size:0.75rem;color:#ccc">{{currentInfo.studentOrTeacherCode}}</div>
                </div>
                <div style="margin-left:1rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{schoolName}}</div>
            </div>
        </div>
    </div>
    <van-popup v-model="show"  position="bottom" round  >
        <div  style="padding:1rem 1rem;display:flex;justify-content:space-between;">
            <div style="color:#1989fa;" @click="show = false">取消</div>
            <div style="color:#1989fa;" @click="confirm">确认</div>
        </div>
        <van-picker style="height:80%;" :columns="infoList"  @change="onChange" >
            
        </van-picker>
    </van-popup>
     <!-- <div class="info">
        
    </div> -->
    <div class="info" v-if="first">
        <div style="padding:1rem 1rem;">
           <div>模块菜单</div>
           <div style="display:flex; justify-content: flex-start;flex-wrap:wrap ;padding:1rem 0rem;">
                <div style="width:20%;height:20vw;margin-right:7%;text-align:center;" @click="toCard">
                   <div>
                         <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        src="http://file.qingzhou.link/wechat-mp/icons8-pos-terminal-96.png" rel="external nofollow" 
                        />
                   </div>
                   <div class="font_size">
                       一卡通
                   </div>
               </div>
               <div style="width:20%;height:20vw;margin-right:7%;text-align:center;" @click="leave">
                   <div>
                        <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        src="http://file.qingzhou.link/wechat-mp/icons8-leave-96.png" rel="external nofollow" 
                        />
                   </div>
                   <div class="font_size">
                      请假
                   </div>
               </div>
               <div style="width:20%;height:20vw;margin-right:7%;text-align:center;" @click="setting">
                   <div>
                        <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        :src="require('./img/set.png')" rel="external nofollow" 
                        />
                   </div>
                   <div class="font_size">
                      设置
                   </div>
               </div>
           </div>
        </div>
        
    </div>
    <div v-if="!first" style="width:100%;margin:0 auto;display:flex; flex-direction:column;">
      <div style="width:100%;flex:1">
         <van-image
            width="100%"
            height="100%"
            fit="cover"
            :src="require('./img/title.png')" rel="external nofollow" 
            />
      </div>
      <div style="width:100%;">
         <div style="margin:0 auto;margin:45px 0;text-align:center;">
              <p>点击授权登录，需要获取掌银登录状态</p>
            </div>
            <div style="width:80%;margin:0 auto;">
              <van-button type="primary" text="授权登录" style="background-color:#F5AD3F;width:100%;margin:0 auto;  border-radius: 50px;border:1px solid #F5AD3F;" @click="toDetail()" />
            </div>  
      </div>  
    </div>
    </van-pull-refresh>
    
  </div>
</template>

<script>
import Vue from 'vue';

import {getAuthorizationCode,abcCode,checkBindd,getOpenId,getChilgrenInfo,getToken,getCoverImage,getSchoolInfo} from '@/api/http'
import { Dialog ,Toast } from 'vant';
Vue.use(Dialog);
export default {
  name: 'menuList',
  components: {
   
  },
  data(){
    return{
      openId:null,
      url:"",
      images: [],
      LodingShow:false,
      show:false,
      infoList:[],
      value:{},
      index:0,
      userInfo:{
        schoolName:null
      },
      schoolName:null,
      currentInfo:{
        deptName:null,
        name:null,
        studentOrTeacherCode:null,
        avatar:null
      },
      first:false,
      loading:false,
    }
  },
  methods:{
    async onRefresh(){
      this.loading = true
        Toast('刷新成功');
        checkBindd(localStorage.getItem('openId')).then(res1=>{
            console.log(res1)
            if(res1.data.code == 200){
              // this.$router.push('/menu')
              sessionStorage.setItem("token", JSON.stringify(res1.data.data.token))
              sessionStorage.setItem("userInfo", JSON.stringify(res1.data.data.userInfo))
              console.log(JSON.parse(sessionStorage.getItem('userInfo')))
              this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
              this.getChilgrenInfo()
              // this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
              // console.log(this.userInfo,this.currentInfo)
            }
        })
        this.getToken()
        this.loading = false;
    },
      toDetail(){
        this.first = false
        let urlStr = "https://apinh.sjzdezhong.com/payQuickly/api/payNotify.do?shName=OPENABCHDKE&type=H5";
        window.location.href = urlStr;
      },
    //跳转设置界面
      setting(){
          this.$router.push('/setting')
      },
      //进入一卡通充值
      toCard(){
          this.$router.push('/balance')
      },
      //跳转请假界面
      leave(){
          console.log(this.currentInfo)
          if(this.currentInfo.roles.length === 1 && this.currentInfo.roles[0].id === 5){
                this.$router.push("/leave")
            }else{
                this.currentInfo.roles.forEach(item=>{
                    if(item.id === 6){
                        this.$router.push("/teacherLeave")
                    }
                })
            }
      },
    //点解切换角色
    changeShow(){
          this.show = true
    },
    //获取学校名字
    getSchoolName(schoolId){
      getSchoolInfo(schoolId).then(res=>{
          if(res.data.code === 200){
            this.schoolName = res.data.data.deptName
            console.log(this.schoolName)
          }
        })
    },
    //点击弹出框里边的确认
   confirm(){
        this.LodingShow = true;
        this.show = false
        console.log(this.value)
        // this.getSchoolName(this.value.schoolId)
        console.log(this.index)
        sessionStorage.setItem("index", JSON.stringify(this.index))
        // sessionStorage.setItem("currentInfo", JSON.stringify(this.value))
        // this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
        this.getToken()
    },
    onChange(picker, value, index) {
            this.index = index
            this.value = value
            console.log("123")
            console.log(picker)
            console.log(value)
            console.log(index)
    },
    //获取孩子的信息
  async getChilgrenInfo(){
        console.log(this.userInfo)
       await getChilgrenInfo(this.userInfo.id).then(res=>{
            console.log(res)
            if(res.data.code == 200){
              if(res.data.data){
                this.infoList = res.data.data
                if(this.infoList.length>0){
                  this.infoList.forEach((item,index)=>{
                    console.log(item)
                    this.infoList[index]["text"] = item.name
                    this.infoList[index]["keyId"] = item.id
                    this.infoList[index]["schoolId"] = item.userRoles[0].schoolId
                })
                }
              }
                
                
                console.log(this.infoList)
            }
        })
        await this.myInfo()
    },
    //处理自己的信息
    myInfo(){
      let myinfo = this.userInfo.schools
      let list = []
      console.log(this.userInfo)
      if(myinfo && myinfo.length>=1){
          for(let i = 0;i<myinfo.length;i++){
              if(myinfo[i].roles && myinfo[i].roles.length == 1 && myinfo[i].roles[0].id == 7){
                  myinfo.splice(i,1);
              }else{
                  let info = {
                      text:this.userInfo.name+'('+myinfo[i].name+')',
                      keyId:this.userInfo.id,
                      schoolName:myinfo[i].name,
                      schoolId:myinfo[i].id,
                      deptId:this.userInfo.schoolDeptId,
                      id:this.userInfo.id,
                      name:this.userInfo.name,
                      avatar:this.userInfo.avatar,
                      roles:myinfo[i].roles,
                      studentOrTeacherCode:this.userInfo.studentOrTeacherCode,
                  }
                  if(myinfo[i].depts != 'null'){
                    info.deptName = myinfo[i].depts[0].name
                  }else{
                    info.deptName = myinfo[i].roles.namezh
                  }
                  list.push(info)
                }
                  
              }
          
      }
      console.log(this.infoList)
        this.infoList= this.infoList.concat(list)
        console.log(this.infoList)
        this.getToken()
    },
    getToken(){
        console.log(this.infoList)
        let index = JSON.parse(sessionStorage.getItem('index'))
        if(index){
            console.log("找到index")
             getToken(this.infoList[index].schoolId,localStorage.getItem("openId")).then(res=>{
                console.log(res);
                sessionStorage.setItem("token", JSON.stringify(res.data.data.token))
                sessionStorage.setItem("currentInfo", JSON.stringify(this.infoList[index]))
                this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
                if(!this.currentInfo.hasOwnProperty('studentOrTeacherCode')){
                  this.currentInfo.studentOrTeacherCode = null
                }
                console.log(this.currentInfo)
                this.getSchoolName(this.currentInfo.schoolId)
                this.getImageList()
                this.LodingShow = false;
            })
        }else{
            console.log("没有找到index");
            getToken(this.infoList[0].schoolId,localStorage.getItem("openId")).then(res=>{
                console.log(res);
                sessionStorage.setItem("token", JSON.stringify(res.data.data.token))
                sessionStorage.setItem("currentInfo", JSON.stringify(this.infoList[0]))
                this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
                console.log(this.currentInfo)
                this.getSchoolName(this.currentInfo.schoolId)
                this.getImageList()
                this.LodingShow = false;
            })
        }
         
    },
    getImageList(){
         let index = JSON.parse(sessionStorage.getItem('index'))
        if(index){
             getCoverImage(this.infoList[index].schoolId).then(res=>{
                console.log(res)
                this.images = JSON.parse(res.data.data.configValue)
             })
        }else{
             getCoverImage(this.infoList[0].schoolId).then(res=>{
                console.log(res)
                this.images = JSON.parse(res.data.data.configValue)
             })
        }
       
    },

      //获取授权码
    getAuthorizationCode(){
      var timestamp = (new Date()).valueOf()
      var timestamp1 = Date.parse(new Date())
      var timestamp2=new Date().getTime()
      console.log(timestamp);
      console.log(timestamp1);
      console.log(timestamp2);

      // getAuthorizationCode('347ada77e56f443afd689f9ecd64294669efaf479514dcc67f1cf6a7cc9749','https://api.qingzhou.link/bind',timestamp2,"openid,phone,name,certnum,custinfo,cardlist,mreginfo,reglvl,nickname,gender,address,deliveryAddr,email,profession,nationality,head").then(res=>{
      //   console.log(res)
      // })
     

    },
    checkBind(openId){
      checkBindd(openId).then(res=>{
        console.log(res)
        if(res.data.code == 200){
          // this.$router.push('/menu')
          sessionStorage.setItem("token", JSON.stringify(res.data.data.token))
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.data.userInfo))
          console.log(JSON.parse(sessionStorage.getItem('userInfo')))
          this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
          this.getChilgrenInfo()
          // this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
          // console.log(this.userInfo,this.currentInfo)
        }else{
            this.$router.push('/manualBind')
        }
      })
    }
  },
  mounted(){
    // getOpenId('OPENABCHDKE').then(res=>{
    //   console.log(res)
    // })
    // if(sessionStorage.getItem('koken')){

    // }else{
    //   Dialog.confirm({
    //         title: '提示',
    //         message: '用户信息登录失效，是否重新登录？',
    //       })
    //         .then(() => {
    //           // on confirm
    //           this.$router.push('/manualBind')
    //           return
    //         })
    //         .catch(() => {
    //           // on cancel
    //           return
    //         });
    // }
    // localStorage.setItem('openId','b968ae69c13e95339cc13605313fd94a4ddb28015a2647244718ef9db44e8f')
    console.log(window.location.href)
    if(window.location.href.search("openId") != -1){
      let openId = window.location.href.split("=")[1].split("&")[0];
      if(openId.search('null') != -1){
        openId = openId.split('null')[0]
      }
      console.log(openId)
        window.localStorage.setItem("openId",openId)
        // alert("又有他又")
    }
    if(localStorage.getItem('openId')){
    //获取学校名字
    
      // getSchoolInfo(this.value.schoolId).then(res=>{
      //   if(res.data.code === 200){
      //     this.schoolName = res.data.data.deptName
      //     console.log(this.schoolName)
      //   }
      // })
      this.first = true
      checkBindd(localStorage.getItem('openId')).then(res1=>{
              console.log(res1)
              if(res1.data.code == 200){
                // this.$router.push('/menu')
                sessionStorage.setItem("token", JSON.stringify(res1.data.data.token))
                sessionStorage.setItem("userInfo", JSON.stringify(res1.data.data.userInfo))
                console.log(JSON.parse(sessionStorage.getItem('userInfo')))
                this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                this.getChilgrenInfo()
                // this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
                // console.log(this.userInfo,this.currentInfo)
              }else{
                Dialog.confirm({
                  title: '提示',
                  message: '用户信息登录失效了，是否重新登录？',
                })
                  .then(() => {
                    // on confirm
                    this.$router.push('/manualBind')
                    return
                  })
                  .catch(() => {
                    // on cancel
                    
                  });
                  
              }
            })
            return 
    }
    // this.getAuthorizationCode()

    this.url = window.location.href
    console.log("hjjjjj",this.url)
    console.log(this.url.search("code"))
    if(this.url.search("code") != -1){
      let url = window.location.href.split("=")
      let code = null
       this.first = true
        code = window.location.href.split("=")[1].split("&")[0]
        console.log(code)
        getOpenId(code).then(res=>{
          if(res.data.code === 200){
            console.log(res.data.data)
            localStorage.setItem("openId",res.data.data)
            // this.openId = res.data.data
            // this.checkBind(res.data.data)
            checkBindd(res.data.data).then(res1=>{
              console.log(res1)
              if(res1.data.code == 200){
                // this.$router.push('/menu')
                sessionStorage.setItem("token", JSON.stringify(res1.data.data.token))
                sessionStorage.setItem("userInfo", JSON.stringify(res1.data.data.userInfo))
                console.log(JSON.parse(sessionStorage.getItem('userInfo')))
                this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                this.getChilgrenInfo()
                // this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'))
                // console.log(this.userInfo,this.currentInfo)
              }else{
                Dialog.confirm({
                  title: '提示',
                  message: '用户信息登录失效，是否重新登录？',
                })
                  .then(() => {
                    // on confirm
                    this.$router.push('/manualBind')
                    return
                  })
                  .catch(() => {
                    // on cancel
                    
                  });
                  
                  // this.$router.push('/manualBind')
              }
            })
          }
        })
    }else{
      this.first = false
      // let urlStr = "https://www.abchina.com/luascript/oauthLogin/{\"client_id\":\"82284001-7aad-49a7-8ca5-aecd5b9e9870\",\"redirect_uri\":\"http://abc-bank.qingzhou.link/\",\"state\":\"123456\",\"scope\":\"openid\",\"response_type\":\"code\"}";
      // window.location.href = urlStr;
      // var iFrame = document.createElement("iframe"); 
      //  iFrame.style.height = "1px"; 
      //   iFrame.style.width = "1px"; 
      //   iFrame.style.display = "none"; 
      //  iFrame.src = urlStr; 
      //  document.body.appendChild(iFrame); 
      //   setTimeout(function(){ 
      //      iFrame.remove(); 
      //       },100);
    }
  }
}
</script>
<style scoped>
.home{
  width: 100%;
  height: 100%;
}
 .menuList{
        width: 100%;
        height: 100%; 
    }
    .info{
        width:95%;
        margin:auto;
        margin-top:1rem;
        background-color: #ffffff;
        /* padding:1rem 1rem; */
    }
    .font_size{
        font-size: 1rem;
    }
    .bg{
        width: 100%;
        background-image:url('./img/indexStudent.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
</style>
